"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattedToValue = exports.valueToFormatted = void 0;
var id_number_format_1 = require("./id-number-format");
var phone_format_1 = require("./phone-format");
var currency_format_1 = require("./currency-format");
/**
 * Función que obtiene un string formateado para aparecer en el input de la interfaz de usuario a partir del valor de la variable manejada en javascript
 * @param {*} type Tipo del valor a formatear, puede ser idNumber, phoneNumber, currencyNumber
 * @param {*} country País que define la regla a aplicar
 * @param {*} value Valor obtenido desde las variables manejadas en javascript
 * @param {*} precision Valor que indica la precision decimal que se desea formatear
 * @returns String formateado que aparece en el input de la interfaz del usuario
 */
var valueToFormatted = function (type, country, value, precision) {
    if (precision === void 0) { precision = 2; }
    var map = {
        idNumber: {
            cl: id_number_format_1.clIdNumberToFormattedIdNumber,
            pe: id_number_format_1.peIdNumberToFormattedIdNumber,
            br: id_number_format_1.brIdNumberToFormattedIdNumber
        },
        phoneNumber: {
            cl: phone_format_1.clPhoneToFormattedPhone,
            pe: phone_format_1.pePhoneToFormattedPhone,
            br: phone_format_1.brPhoneToFormattedPhone
        },
        currencyNumber: {
            cl: currency_format_1.clNumberToFormattedCurrency,
            pe: currency_format_1.peNumberToFormattedCurrency,
            br: currency_format_1.brNumberToFormattedCurrency
        }
    };
    return map[type][country](value, precision);
};
exports.valueToFormatted = valueToFormatted;
/**
 * Función que obtiene un string formateado para aparecer en el input de la interfaz de usuario a partir del valor de la variable manejada en javascript
 * @param {*} type Tipo del valor a desformatear, puede ser idNumber, phoneNumber, currencyNumber
 * @param {*} country País que define la regla a aplicar
 * @param {*} formatted Valor formateado al que queremos limpiar
 * @returns String formateado que aparece en el input de la interfaz del usuario
 */
var formattedToValue = function (type, country, formatted) {
    var map = {
        idNumber: {
            cl: id_number_format_1.clFormattedIdNumberToIdNumber,
            pe: id_number_format_1.peFormattedIdNumberToIdNumber,
            br: id_number_format_1.brFormattedIdNumberToIdNumber
        },
        phoneNumber: {
            cl: phone_format_1.clFormattedPhoneToPhone,
            pe: phone_format_1.peFormattedPhoneToPhone,
            br: phone_format_1.brFormattedPhoneToPhone
        },
        currencyNumber: {
            cl: currency_format_1.clFormattedCurrencyToNumber,
            pe: currency_format_1.peFormattedCurrencyToNumber,
            br: currency_format_1.brFormattedCurrencyToNumber
        }
    };
    return map[type][country](formatted);
};
exports.formattedToValue = formattedToValue;
